// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"6f2fd6e1","469":"f5ab52e6"}[chunkId] + ".js";
};